/* Coupon state belongs to Shopify; browser storage is only a display cache. */
(function () {
  'use strict';
  if (window.PesadoCartDiscount) return;
  window.PesadoCartDiscount = { version: '2026-09-18' };

  var fieldSelector = 'input[id="CartDiscountcode"]';
  var saveSelector = '[data-action="save-discountcode"]';
  var removeSelector = '[data-pesado-remove-discount]';
  var storageKey = 'CartDiscountcode';
  var confirmed = null;
  var pending = false;
  var revision = 0;
  var readPromise;
  var dirty = new WeakSet();
  var language = (document.documentElement.lang || 'en').split('-')[0];
  var copy = {
    en: ['Save', 'Remove coupon', 'Updating coupon…', 'Coupon removed.', 'Coupon updated.', 'This coupon does not apply to this cart.', 'Could not confirm the change. Please try again.', 'Save or remove your coupon before checkout.'],
    es: ['Guardar', 'Quitar cupón', 'Actualizando cupón…', 'Cupón eliminado.', 'Cupón actualizado.', 'Este cupón no se aplica a este carrito.', 'No se pudo confirmar el cambio. Intentá de nuevo.', 'Guardá o quitá el cupón antes de continuar.'],
    ja: ['保存', 'クーポンを削除', 'クーポンを更新中…', 'クーポンを削除しました。', 'クーポンを更新しました。', 'このクーポンは現在のカートには適用されません。', '変更を確認できませんでした。もう一度お試しください。', '購入手続きの前にクーポンを保存または削除してください。']
  }[language] || null;
  if (!copy) copy = ['Save', 'Remove coupon', 'Updating coupon…', 'Coupon removed.', 'Coupon updated.', 'This coupon does not apply to this cart.', 'Could not confirm the change. Please try again.', 'Save or remove your coupon before checkout.'];

  function root() { return (window.Shopify && window.Shopify.routes.root) || '/'; }
  function fields() { return Array.from(document.querySelectorAll(fieldSelector)); }
  function codes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) throw new Error('Missing confirmed coupon state');
    return cart.discount_codes.map(function (entry) { return entry.code; }).filter(Boolean).join(', ');
  }
  function normalize(value) {
    return Array.from(new Set(value.split(',').map(function (code) { return code.trim().toUpperCase(); }).filter(Boolean))).join(',');
  }
  function persist(value) {
    try {
      if (value) localStorage.setItem(storageKey, value);
      else localStorage.removeItem(storageKey);
    } catch (_) { /* Saving/removing must work with storage disabled. */ }
  }
  function scope(field) { return field.closest('.t4s-mini_cart-tool__wrap') || field.parentElement; }
  function message(text, error) {
    document.querySelectorAll('[data-pesado-discount-status]').forEach(function (node) {
      node.textContent = text;
      node.classList.toggle('is-error', !!error);
    });
  }
  function sync(cart, force) {
    confirmed = codes(cart);
    persist(confirmed);
    fields().forEach(function (field) {
      if (force || !dirty.has(field)) {
        field.value = confirmed;
        dirty.delete(field);
      }
      // Do not resubmit a stale local code to checkout.
      field.removeAttribute('name');
    });
    document.querySelectorAll('[data-cart-discount]').forEach(function (field) {
      field.value = confirmed;
      if (confirmed) field.setAttribute('name', 'discount');
      else field.removeAttribute('name');
    });
    document.querySelectorAll(removeSelector).forEach(function (button) { button.hidden = !confirmed; });
  }
  async function request(path, options) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(root() + path, Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal }, options));
      if (!response.ok) throw new Error('Cart request failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  function refresh() {
    if (pending) return Promise.resolve();
    if (readPromise) return readPromise;
    var currentRevision = revision;
    readPromise = request('cart.js').then(function (cart) {
      if (currentRevision === revision && !pending) sync(cart, false);
    }).catch(function () { /* A read failure never invents a successful removal. */ }).finally(function () { readPromise = null; });
    return readPromise;
  }
  function busy(value) {
    pending = value;
    document.querySelectorAll(fieldSelector + ', ' + saveSelector + ', ' + removeSelector).forEach(function (node) {
      node.disabled = value;
      node.setAttribute('aria-busy', String(value));
    });
  }
  async function save(field, remove) {
    if (pending) return;
    var value = remove ? '' : normalize(field.value);
    var section = window.cartT4SectionID || 'mini_cart';
    revision += 1;
    busy(true);
    message(copy[2], false);
    try {
      var cart = await request('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: value, sections: ['cart_data', section], sections_url: location.pathname + location.search })
      });
      var actual = codes(cart);
      if (!value && actual) throw new Error('Removal not confirmed');
      sync(cart, true);
      var rendered = false;
      if (cart.sections && cart.sections.cart_data && cart.sections[section] && window.T4SThemeSP && T4SThemeSP.Cart) {
        try { T4SThemeSP.Cart.renderContents(cart.sections); rendered = true; } catch (_) { /* Fall back to the theme's normal refresh. */ }
      }
      if (!rendered) document.dispatchEvent(new CustomEvent('cart:refresh'));
      var applies = cart.discount_codes.length > 0 && cart.discount_codes.every(function (entry) { return entry.applicable; });
      message(!value ? copy[3] : applies ? copy[4] : copy[5], !!value && !applies);
    } catch (_) {
      // A failed/uncertain POST is not retried automatically.
      dirty.add(field);
      message(copy[6], true);
    } finally { busy(false); }
  }
  function prepare() {
    fields().forEach(function (field) {
      if (field.dataset.pesadoDiscountReady) return;
      field.dataset.pesadoDiscountReady = 'true';
      field.removeAttribute('name');
      var container = scope(field);
      var controls = document.createElement('div');
      controls.className = 'pesado-discount-controls';
      if (!container.querySelector(saveSelector)) {
        var apply = document.createElement('button');
        apply.type = 'button';
        apply.dataset.action = 'save-discountcode';
        apply.textContent = copy[0];
        controls.appendChild(apply);
      }
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.pesadoRemoveDiscount = '';
      remove.textContent = copy[1];
      remove.hidden = !confirmed;
      controls.appendChild(remove);
      var status = document.createElement('p');
      status.dataset.pesadoDiscountStatus = '';
      status.className = 'pesado-discount-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      controls.appendChild(status);
      field.closest('.t4s-field') ? field.closest('.t4s-field').after(controls) : field.after(controls);
      if (confirmed !== null) field.value = confirmed;
      refresh();
    });
  }
  document.addEventListener('click', function (event) {
    var cancel = event.target.closest && event.target.closest('[data-cart-tool_close]:not(' + saveSelector + ')');
    if (cancel && cancel.closest('.is--discount') && !pending && confirmed !== null) {
      fields().forEach(function (field) { field.value = confirmed; dirty.delete(field); });
      message('', false);
    }
    var button = event.target.closest && event.target.closest(saveSelector + ', ' + removeSelector);
    if (!button) return;
    var container = button.closest('.t4s-mini_cart-tool__wrap') || button.parentElement.parentElement;
    var field = container.querySelector(fieldSelector);
    if (!field) return;
    event.preventDefault();
    event.stopImmediatePropagation(); // Own only coupon controls; suppress the legacy /discount/ request.
    save(field, button.matches(removeSelector));
  }, true);
  document.addEventListener('input', function (event) {
    if (!event.target.matches(fieldSelector)) return;
    dirty.add(event.target);
    event.target.removeAttribute('name');
    event.stopImmediatePropagation(); // Legacy debounce would submit an unconfirmed value to checkout.
    message('', false);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches(fieldSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    save(event.target, false);
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.target.querySelector(fieldSelector + ', [data-cart-discount]')) return;
    if (pending || fields().some(function (field) { return dirty.has(field); })) {
      event.preventDefault();
      event.stopImmediatePropagation();
      message(pending ? copy[2] : copy[7], true);
    }
  }, true);
  document.addEventListener('cart:updated', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', function (event) { if (event.key === storageKey) refresh(); });
  new MutationObserver(prepare).observe(document.body, { childList: true, subtree: true });
  prepare();
  refresh();
}());
